export function useMainPhoto() {
  const photo = { url: "/images/christopher.jpg" };
  const loading = false;
  const refetch = () => {};

  return { photo, loading, refetch };
}
